import React from "react";
import { AppBar, Box, Container, Fade, useMediaQuery } from "@mui/material";
import Logo from "../images/logo.png";

const LandingHeader = () => {
  const mdDown = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        //top: scrollDirection === "down" ? mdDown ? "-100px" : "-120px" : "0",
        zIndex: "1400",
        height: "100px",
        transition: "top 0.3s ease-in-out",
        backgroundColor: "transparent",
        boxShadow: "none",
        ".admin-bar &": {
          top: "32px",
        },
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          margin: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Box
          sx={{
            width: "80px",
            height: "80px",
          }}
        >
          <Fade in={true}>
            <img
              src={Logo}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
              // onClick={() => {
              //   //home page
              //   navigate("/");
              // }}
            />
          </Fade>
        </Box>
      </Container>
    </AppBar>
  );
};

export default LandingHeader;
